import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id B6AD150F-5C19-421E-9A2A-D3F43F38D440
 * name land-plots
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/land-plots.svg
 * tags
 * - Agriculture 
 */
export const LandPlotsIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M4 4H8V14H4V4M4 20V16H8V20H4M20 20H10V10H20V20M20 8H10V4H20V8Z" /></>, 'LandPlotsIcon');
export default LandPlotsIcon